import React, { useEffect, useMemo, useState } from 'react'
import georisques from 'assets/pictures/georisques.png'
import gesteau from 'assets/pictures/gesteau.png'
import logoInsee from 'assets/pictures/logo-insee.png'
import eaufrance from 'assets/pictures/logos/eaufrance.jpg'
import { push } from '@lagunovsky/redux-react-router'
import ImportFileContent from 'import/components/content/ImportFileContent'
import i18n from 'simple-react-i18n'
import useTitle from 'utils/customHook/useTitle'
import { getDataWithHeaders } from 'utils/ExportDataUtil'
import {
    eaufranceCityLink,
    georisquesCityDefaultLink,
    gesteauCityDefaultLink,
    inseeCityDefaultLink,
} from '../../../../conf/SieauConstants'
import HomeAction from '../../../../home/actions/HomeAction'
import {
    PATH_REFERENCIAL,
    PATH_REFERENCIAL_CITY,
    PATH_REFERENCIAL_CITY_NEW,
} from '../../../../home/constants/RouteConstants'
import CityAction from '../actions/CityAction'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import useActions from 'utils/customHook/useActions'
import SearchTable from 'referencial/components/SearchTable'
import { getExportReferencialData, reloadJobSync } from 'referencial/util/ReferencialUtils'
import { REFERENCIAL_TYPE_NAME, REFERENTIAL_JOBSYNC_ID } from 'referencial/constants/ReferencialConstants'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import ProgressCard from 'components/card/ProgressCard'
import ReferencialAction from '../../../action/ReferencialAction'
import JobSyncStatus from '../../JobSyncStatus'

const cityHeaders = ['code', 'name', 'email', 'phone']
const headers = ['code', 'name', 'situation', 'departmentNumber', 'area', 'countryCode', 'x', 'y', 'projection', 'email', 'phone', 'population']
const headersCsv = ['Code*', 'Nom*', 'Pays', 'Situation', 'Email', 'Telephone', 'Superficie', 'Population', 'X', 'Y', 'Code Projection']

const CitiesApp = () => {
    const {
        cities,
    } = useSelector(store => ({
        cities: store.CityReducer.cities,
    }), shallowEqual)

    const [fileContent, setFileContent] = useState('')
    const [exportData, setExportData] = useState([])
    const [jobSync, setJobSync] = useState(undefined)

    useEffect(() => {
        reloadJobSync(REFERENTIAL_JOBSYNC_ID.city, setJobSync)
    }, [])

    useEffect(() => {
        if (jobSync && jobSync.executions[0]) {
            if (!jobSync.executions[0].statusCode) {
                setTimeout(() => {
                    reloadJobSync(REFERENTIAL_JOBSYNC_ID.city, setJobSync)
                }, 5000)
            }
        }
    }, [jobSync])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(HomeAction.setHelpLink('', ''))
    }, [])

    const {
        isLoaded,
        progress,
    } = useProgressDispatch(() => {
        const promises = [() => CityAction.fetchCities(true)]
        return promises.map(p => dispatch(p()))
    }, [])

    useTitle(() => [{
        title: i18n.referencials,
        href: PATH_REFERENCIAL,
    }, {
        title: i18n.towns,
        href: PATH_REFERENCIAL_CITY,
    }], [])

    const onImportFile = (e) => {
        const reader = new FileReader()
        const file = e.target.files[0]
        reader.onload = upload => setFileContent(upload.target.result)
        reader.readAsDataURL(file)
    }

    const getFileContent = (title, subtitle, extension) => (
        <ImportFileContent
            title={title}
            subtitle={subtitle}
            extension={extension}
            headersCsv={headersCsv}
            onImportFile={f => onImportFile(f)}
        />
    )

    const data = useMemo(() => getExportReferencialData(cities), [cities])

    useActions(() => {
        return {
            new: () => dispatch(push(PATH_REFERENCIAL_CITY_NEW)),
            referencialActions: {
                actions: {
                    export: {
                        data: getDataWithHeaders(exportData, headers),
                        titleFile: i18n.cityList,
                    },
                    sync: {
                        updateAction: options => dispatch(ReferencialAction.launchSyncJob(REFERENTIAL_JOBSYNC_ID.city, options, () => reloadJobSync(REFERENTIAL_JOBSYNC_ID.city, setJobSync))),
                        onImportXml: () => dispatch(CityAction.fetchImportCityXML(fileContent)),
                        onImportCsv: () => dispatch(CityAction.fetchImportCityCSV(fileContent)),
                        xmlContent: getFileContent(i18n.xmlSyncChoice, i18n.importXmlFileToZanderReference, '.xml'),
                        csvContent: getFileContent(i18n.csvSyncChoice, i18n.importCsvZanderReference, '.csv'),
                        fileContentIsValid: !!fileContent,
                    },
                    purge: {
                        onPurge: () => dispatch(CityAction.purgeCity()),
                    },
                },
            },
            links: [{
                href: inseeCityDefaultLink,
                img: logoInsee,
                label: i18n.insee.toUpperCase(),
            }, {
                href: georisquesCityDefaultLink,
                img: georisques,
                label: i18n.georisques.toUpperCase(),
            }, {
                href: gesteauCityDefaultLink,
                img: gesteau,
                label: i18n.gesteau.toUpperCase(),
            }, {
                href: eaufranceCityLink,
                img: eaufrance,
                label: i18n.eaufrance.toUpperCase(),
            }],
        }
    }, [exportData, fileContent])

    return !isLoaded ? (
        <ProgressCard progress={progress} withMessage />
    ) : (
        <SearchTable
            useNewTable
            title={i18n.cityList}
            sessionKey={REFERENCIAL_TYPE_NAME.city}
            data={data}
            setExportData={setExportData}
            headers={cityHeaders}
            onClick={city => dispatch(push(`/referencial/city/${city.id}/dashboard`))}
            jobSync={<JobSyncStatus jobSync={jobSync}/>}
        />
    )
}

export default CitiesApp
